import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IResponseWithLoading, ISiteSlim, ITeam } from "App/Modules/Models";
import type { IPartnersRepository, ITeamsRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class AddSiteToTeamComponentController {
    public static $inject: string[] = ["$scope", "mmTeamsRepository", "mmPartnersRepository"];

    public sites: IResponseWithLoading<ISiteSlim[]>;

    public site: ISiteSlim;

    public displayValidationError = false;

    public resolve: IFormContainerResolve<ISiteSlim, ITeam>;

    public addResponse: IResponseWithLoading<ISiteSlim>;

    constructor(
        private readonly $scope: IScope,
        private readonly teamsRepository: ITeamsRepository,
        private readonly partnersRepository: IPartnersRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.partnersRepository.getPartnerSites(this.resolve.bindings.partnerId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ISiteSlim[]>) => {
                    this.sites = response;
                    if (!response.hasError && response.data) {
                        response.data = response.data.filter(
                            (s) => !this.resolve.bindings.sites.some((ts) => s.id === ts.id),
                        );
                        this.sites = response;
                    }
                },
                (error) => {
                    this.sites = error;
                },
            );

        this.$scope.$watch("$ctrl.site", (newValue) => {
            if (newValue !== undefined) {
                this.displayValidationError = false;
            }
        });
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public addSiteToTeam() {
        if (this.site !== undefined) {
            extendWithLoadingAndFail(this.teamsRepository.addSite(this.resolve.bindings.id, this.site))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (addResponse: IResponseWithLoading<ISiteSlim>) => {
                        this.addResponse = addResponse;
                        if (!addResponse.isLoading && addResponse.data) {
                            this.resolve.options.onOk(addResponse.data);
                        }
                    },
                    (error) => {
                        this.addResponse = error;
                    },
                );
        } else {
            this.displayValidationError = true;
        }
    }
}
